import { useMutation } from '@tanstack/react-query';

import { Entity } from '../../../../types/utility';
import { handleSuccess } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { patchDocument } from '../../requests/patchDocument';
import { DocumentParams } from '../../types/DocumentParams';

export const useUpdateDocument = (documentParams: DocumentParams) => {
  const { constructPatch } = useRequestConstructor();

  const { mutateAsync: updateDocument, ...rest } = useMutation({
    mutationFn: ({ documentId, data }: { documentId: string; data: Entity }) =>
      patchDocument(constructPatch, documentId, documentParams, data),
    onSuccess: () => handleSuccess('Updated'),
  });

  return { updateDocument, ...rest };
};
